import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://cis.mwsgkp.in";

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// =========================================================
// LOGIN
// =========================================================

export const loginUser = async (
  username,
  password,
  rememberMe = true
) => {
  try {
    const response = await api.post(
      "/auth/login",
      {
        username,
        password,
        rememberMe,
      }
    );

    const data = response.data;

    if (data.success && data.token) {
      if (rememberMe) {
        localStorage.setItem(
          "token",
          data.token
        );

        sessionStorage.removeItem("token");
      } else {
        sessionStorage.setItem(
          "token",
          data.token
        );

        localStorage.removeItem("token");
      }

      localStorage.setItem(
        "user",
        JSON.stringify(data.user)
      );
    }

    return data;
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Unable to connect to server",
    };
  }
};

// =========================================================
// GET CURRENT USER
// =========================================================

export const getCurrentUser = async () => {
  try {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    if (!token) {
      return {
        success: false,
        message: "Not authenticated",
      };
    }

    const response = await api.get(
      "/auth/me",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      localStorage.setItem(
        "user",
        JSON.stringify(response.data.user)
      );
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Session expired",
    };
  }
};

// =========================================================
// LOGOUT
// =========================================================

export const logoutUser = async () => {
  try {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    if (token) {
      await api.post(
        "/auth/logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
  } catch (error) {
    console.error("Logout API error:", error);
  } finally {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    localStorage.removeItem("user");
  }
};

// =========================================================
// AUTH STATUS
// =========================================================

export const isAuthenticated = () => {
  return !!(
    localStorage.getItem("token") ||
    sessionStorage.getItem("token")
  );
};